import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden bg-gradient-to-br from-beige to-weiss" data-id="element-111">
      {/* Abstract animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-112">
        <motion.div animate={{
        scale: [1, 1.1, 1],
        opacity: [0.3, 0.5, 0.3],
        x: [0, 50, 0],
        y: [0, -30, 0]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] rounded-full bg-royal-blue/5 blur-3xl" data-id="element-113" />
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.2, 0.4, 0.2],
        x: [0, -40, 0],
        y: [0, 40, 0]
      }} transition={{
        duration: 18,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] rounded-full bg-weiss/60 blur-3xl" data-id="element-114" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto mt-16" data-id="element-115">
        <motion.h1 initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-5xl md:text-7xl lg:text-[5.5rem] font-heading text-schwarz leading-tight mb-6 text-balance" data-id="element-116">
          Ihr Lächeln.
          <br data-id="element-117" />
          Unsere Berufung.
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-warm-gray font-body tracking-wide uppercase letter-spacing-2" data-id="element-118">
          Zahnarztpraxis edel & weiss — Nürnberg
        </motion.p>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-119">
        <span className="text-xs text-warm-gray uppercase tracking-widest mb-2 font-body" data-id="element-120">
          Scrollen
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-121">
          <ChevronDownIcon className="w-5 h-5 text-royal-blue" data-id="element-122" />
        </motion.div>
      </motion.div>
    </section>;
}